import { render, staticRenderFns } from "./CheckoutProductItems.vue?vue&type=template&id=0505b5c4&scoped=true"
import script from "./CheckoutProductItems.vue?vue&type=script&lang=js"
export * from "./CheckoutProductItems.vue?vue&type=script&lang=js"
import style0 from "./CheckoutProductItems.vue?vue&type=style&index=0&id=0505b5c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0505b5c4",
  null
  
)

export default component.exports